"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";
import { googleAdsIdFromEnv } from "@/lib/analytics/marketing-setup";
import { isPublicAnalyticsPath } from "@/lib/analytics/page-view";

const googleAdsId = googleAdsIdFromEnv({
  NEXT_PUBLIC_GOOGLE_ADS_ID: process.env.NEXT_PUBLIC_GOOGLE_ADS_ID,
});

export default function GoogleAdsTag() {
  const pathname = usePathname();

  if (!isPublicAnalyticsPath(pathname)) return null;

  return (
    <>
      <Script
        id="google-ads-gtag-src"
        src={`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(googleAdsId)}`}
        strategy="afterInteractive"
      />
      <Script
        id="google-ads-gtag-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
window.dataLayer = window.dataLayer || [];
window.gtag = window.gtag || function gtag(){window.dataLayer.push(arguments);};
window.gtag('js', new Date());
window.gtag('config', '${googleAdsId}');
`.trim(),
        }}
      />
    </>
  );
}
